export default "__VITE_ASSET__05f69260__"